import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AmbitService } from '../ambit.service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpHelperService } from '../http-helper.service';

@Component({
  selector: 'app-driver-detail',
  templateUrl: './driver-detail.component.html',
  styleUrls: ['./driver-detail.component.css']
})
export class DriverDetailComponent implements OnInit {

  public driverDetails: any;
  public sendNotification: boolean = true;
  public loading: boolean = false;
  public message: string = 'Your account is activated.';
  public carsList: any = [];
  public pdfSrc: string = '';

  constructor(public service: AmbitService,
    public httpHelper: HttpHelperService,
    public toaster: ToastrService,
    public router: Router,
    public route: ActivatedRoute) {
    if (this.service.adminUser.userAccess.drivers == 'None') { this.router.navigate(['/home']); }
    if (this.route.snapshot.params['id']) { service.driverId = this.route.snapshot.params['id']; }
  }

  ngOnInit() {
    this.service.driverId = this.route.snapshot.params['id'];
    if (this.service.driverId) {
      this.service.getDriverDetailData(this.service.driverId);
    }
  }

  onStatusChangeCLick(status) {

    if(status=='Active') { this.message = 'Your Orbit account is blocked by Admin.' }
    else { this.message = 'Your Orbit account is activated by Admin.'  }
    this.carsList = [];
    if ((!status || status == 'Pending') && this.service.driverDetails.vehicles && this.service.driverDetails.vehicles.length) {
      for (var i = 0, j = this.service.driverDetails.vehicles.length; i < j; i++) {
        this.carsList.push(JSON.parse(JSON.stringify(this.service.driverDetails.vehicles[i])))
      }
    }
  }

  changeUserStatus(status, check) {
    var self = this, checkPending = '' + self.service.driverDetails.status, updateData: any = {};
    self.loading = true;
    if (check == 'status') {
      updateData['Users/' + self.service.driverDetails.uid + '/status'] = status;
      updateData['DriverDocuments/' + self.service.singleDriver.document.docID + '/status'] = status ? 'Approved' : 'Disapproved';
      if (self.carsList && self.carsList.length) {
        self.carsList.forEach(x => {
          updateData['Vehicles/' + x.carId + '/status'] = 'Active';
          updateData['Vehicles/' + x.carId + '/vehicleCategory'] = x.vehicleCategory;
        });
      }
    } else {
      updateData['Users/' + self.service.driverDetails.uid + '/ambitDriver'] = status;
    }

    firebase.database().ref().update(updateData).then(() => {

      if (check == 'status') {
        if (self.carsList && self.carsList.length) {
          self.carsList.forEach(x => {
            var idx11 = self.service.carList.findIndex(obj => obj.carId == x.carId);
            if (idx11 >= 0) {
              self.service.carList[idx11].status == x.status;
              self.service.carList[idx11].vehicleCategory == x.vehicleCategory;
            }
            var idx12 = self.service.driverDetails.vehicles.findIndex(obj => obj.carId == x.carId);
            if (idx12 >= 0) {
              self.service.driverDetails.vehicles[idx12].status == x.status;
              self.service.driverDetails.vehicles[idx12].vehicleCategory == x.vehicleCategory;
            }
          });
        }
        if (checkPending == 'Pending') {
          self.service.pendigDriversCount--;
          var idx = self.service.driverRequestsList.findIndex(x => x.uid == self.service.driverDetails.uid);
          if (idx >= 0) {
            var user = JSON.parse(JSON.stringify(self.service.driverRequestsList[idx]));
            self.service.driverRequestsList.splice(idx, 1);
            user.status == status;
            self.service.driversList.push(user);
          }
        }
        self.service.singleDriver.document.status = status ? 'Approved' : 'Disapproved';
        self.service.driverDetails.status = status ? 'Active' : 'Blocked';
        document.getElementById('closeStatusMd').click();
        var notifyData: any = { title: 'Orbit Account Status Is Updated', message: ' ' + self.message }
        self.httpHelper.sendEmailNotifications([self.service.driverDetails.email], notifyData)
        if (self.sendNotification) { self.service.sendUserNotification(self.service.driverDetails, notifyData); }
        self.sendNotification = true;
        self.message = 'Your account is activated.';
      } else {
        document.getElementById('closeAmbitMd').click();
        self.service.driverDetails.ambitDriver = status;
      }
      self.loading = false;
    }).catch((error) => {
      self.loading = false;
    })
  }

  checkImg(url) {
    var list = ['.jpg', 'jpeg', '.png', 'webp']
    if (!url) { url = '' }
    var length = url.length, ext = '';
    if (length > 4) { ext = url.substr(length - 4, url.length) }
    ext = ext.toLowerCase()
    return (list.includes(ext))
  }
}